<template>
  <div ref="pdfContainer" />
</template>

<script>
import Document from "@/folia-annotator/v0.0.1/document";
export default {
  name: "DeploymentGuide",
  data() {
    return {
      document: null,
      pdfContainer: null,
    }
  },
  async mounted() {
    const fileName = process.env.VUE_APP_DEVELOPMENT_GUIDE_PDF
    if (!fileName) return
    this.$nextTick(async () => {
      try {
        this.document = new Document(this.$refs.pdfContainer, {
          zoom: 1
        })
        await this.document.open(fileName)
        await this.document.render()
      } catch (e) {
        console.error(e)
      }
    })
  },
  beforeDestroy() {
    this.document.release()
  },
}
</script>

<style scoped>
</style>